define.alias("shared/components/shared/addon-details-card/current-plan", "preview-grid/components/shared/addon-details-card/current-plan");